module.exports = __webpack_public_path__ + "img/acquiesce.62637f1e.png";